import React from "react";

import { Badge } from "../../../common/components/core";
import { ClaimStatus, BesuClaimState } from "../../../types/claim";
import useHasClaimAction from "../hooks/useHasClaimAction";
import { useSelector } from "react-redux";
import { currentRolesSelector } from "../../../redux/slices/auth/selectors";
import { UserRole } from "../../../types/userCurrent";
import { isUserClaimApprover, isUserPO } from "../../../utils/role";

type ClaimStatusBadgeProps = {
    claimState: BesuClaimState;
};
export const ClaimStatusBadge = ({ claimState }: ClaimStatusBadgeProps) => {
    const { hasClaimAction } = useHasClaimAction(claimState);
    const currentRoles = useSelector(currentRolesSelector);
    return (
        <PureClaimStatusBadge
            status={claimState.status}
            hasClaimAction={hasClaimAction}
            role={currentRoles}
        />
    );
};

type PureClaimStatusBadgeProps = {
    status: ClaimStatus;
    hasClaimAction: boolean;
    role: UserRole[];
};

export const PureClaimStatusBadge = ({
    status,
    hasClaimAction,
    role,
}: PureClaimStatusBadgeProps): JSX.Element => {
    if (hasClaimAction && status !== ClaimStatus.APPROVED) {
        return <Badge type="danger">Action Required</Badge>;
    }

    switch (true) {
        case status === ClaimStatus.DISCARDED:
            return <Badge type="discarded">Discarded</Badge>;
        case status === ClaimStatus.APPROVED:
            return <Badge type="success">Approved</Badge>;
        case status === ClaimStatus.CA_REJECTED && isUserClaimApprover(role):
        case status === ClaimStatus.PO_REJECTED && isUserPO(role):
            return <Badge type="danger">Rejected</Badge>;
        default:
            return <Badge type="info">Pending</Badge>;
    }
};
